import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Store } from '@ngrx/store';
import { switchMap, tap } from 'rxjs';

import { selectFilteredGreenHouseMapWithRowNumbers } from 'app/state/green-house-map/green-house-map.selectors';

import { GreenHouseMap } from '../../models';

export interface MapRowListState {
    map: GreenHouseMap;
    filteredRows: number[];
    recentRowNumber: number | undefined;
}

const initialState: MapRowListState = {
    map: {
        name: '',
        number: 0,
        centralPathRowSets: [],
    },
    filteredRows: [],
    recentRowNumber: undefined,
};

@Injectable()
export class MapRowListStore extends ComponentStore<MapRowListState> {
    constructor(private store: Store) {
        super(initialState);
        this.connectToGlobalStore();
    }

    map$ = this.select((state) => state.map);

    updateMapWithFilteredRows = this.updater(
        (state, { map, filteredRows, recentRowNumber }: MapRowListState) => {
            return {
                ...state,
                map,
                filteredRows,
                recentRowNumber,
            };
        },
    );

    connectToGlobalStore = this.effect((trigger$) =>
        trigger$.pipe(
            switchMap(() => this.store.select(selectFilteredGreenHouseMapWithRowNumbers)),
            tap(({ map, filteredRowNumbers, recentRowNumber }) => {
                if (map)
                    this.updateMapWithFilteredRows({
                        map,
                        filteredRows: filteredRowNumbers,
                        recentRowNumber,
                    });
            }),
        ),
    );
}
